import { Page } from 'types'
import { CalendarIntegration } from 'types/calendarIntegrations'
import { hydratePathname } from '../../../../util/hydratePathname'
import { RouteParameters } from '../../../../constants'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { apiVersion, service } from '../service'

const pathname = `/api/${apiVersion}/resources/:${RouteParameters.RESOURCE_ID}/calendar-integrations`

const makeGetCalendarIntegrations =
  (baseUrl: string, config: HttpClientConfig) =>
  async (resourceId: string): Promise<CalendarIntegration[]> => {
    const url = hydratePathname(pathname, {
      [RouteParameters.RESOURCE_ID]: resourceId,
    })

    const { data } = await service(baseUrl).get<Page<CalendarIntegration>>(url, config)

    return data.data
  }

export { makeGetCalendarIntegrations }
